import {
  SMALL,
  MEDIUM,
  LARGE,
  CUSTOM,
} from '../constants/headerLogoImageSizePresets';

export default {
  [SMALL]: 0.3,
  [MEDIUM]: 0.5,
  [LARGE]: 0.8,
  [CUSTOM]: 1,
};
